import {
	ABOUT,
	ABOUT_CREDIT_CARD,
	ABOUT_DEFERRED_PAYMENT,
	ABOUT_HOW_PAY_BY_MALL_PAY,
	ABOUT_INSTALLMENT_PAYMENT,
	ABOUT_INVESTMENTS,
	ABOUT_LOANS,
	ABOUT_MALL_PAY,
	ABOUT_ONLINE_PAYMENT,
	ABOUT_OVERDRAFT,
	ABOUT_PAYMENT_BY_CARD,
	ABOUT_PAYMENT_GATEWAY,
	ABOUT_PAYMENT_ON_DELIVERY,
	ABOUT_PAY_IN_THREE,
	ABOUT_REWARDS,
	ABOUT_SHOP_WISELY,
	ABOUT_TRANSACTION_PAYMENT,
	AFFILIATE_PAGE,
	CARD,
	CAREER,
	CONTACTS,
	DEFERRED_BILLING,
	DOCUMENTS,
	EXCHANGE_RATES,
	FOR_DEVELOPERS,
	FOR_JOURNALISTS,
	GET_MALL_PAY,
	MOBILE_APP,
	OPEN_API,
	PACKAGES,
	PERSONAL_DATA,
	PRICING,
	PRIVACY_SETTINGS,
	PUBLIC_REFERRALS,
	PUBLIC_SUPPORT,
	ROUTES,
	TESTIMONIAL,
	URL_BLOG,
	URL_FACEBOOK,
	URL_INSTAGRAM,
	URL_LINKEDIN,
	URL_VOCABULARY,
	URL_YOUTUBE,
} from 'constants/routes';

import React from 'react';

import { ReactComponent as Blog } from '@skippay/core/assets/logos/monochrome/blog.svg';
import { ReactComponent as Facebook } from '@skippay/core/assets/logos/monochrome/facebook.svg';
import { ReactComponent as Instagram } from '@skippay/core/assets/logos/monochrome/instagram.svg';
import { ReactComponent as LinkedIn } from '@skippay/core/assets/logos/monochrome/linkedin.svg';
import { ReactComponent as Youtube } from '@skippay/core/assets/logos/monochrome/youtube.svg';
import useInitialCountryLocale from '@skippay/core/hooks/useInitialCountryLocale';
import { FormattedMessage } from '@skippay/core/i18n/intl';

type Link = {
	text: JSX.Element;
	url: string;
	ariaLabel?: string;
};

type Output = {
	linksWhereNext: Link[];
	linksInformations: Link[];
	linksForEshops: Link[];
	seoLinks: Link[];
	linksSocial: Link[];
};

function useFooterLinks(): Output {
	const { locale } = useInitialCountryLocale();

	return {
		linksWhereNext: [
			{
				text: (
					<FormattedMessage
						id="Footer.links.aboutSkipPay"
						defaultMessage="Odložená platba Skip Pay"
					/>
				),
				url: ABOUT_MALL_PAY,
			},
			{
				text: <FormattedMessage id="Footer.links.card" defaultMessage="Platební Skip Pay karta" />,
				url: CARD,
			},
			{
				text: <FormattedMessage id="Footer.links.payInThree" defaultMessage="Nákup na Třetinu" />,
				url: ABOUT_PAY_IN_THREE,
			},
			{
				text: <FormattedMessage id="Footer.links.balíčky" defaultMessage="Naše balíčky" />,
				url: PACKAGES,
			},
			{
				text: <FormattedMessage id="Footer.links.mobileApp" defaultMessage="Mobilní aplikace" />,
				url: MOBILE_APP,
			},
			{
				text: (
					<FormattedMessage id="Footer.links.referral" defaultMessage="Odměny za&nbsp;nákupy" />
				),
				url: ABOUT_REWARDS,
			},
			{
				text: (
					<FormattedMessage id="Footer.links.transactionPayment" defaultMessage="Převod peněz" />
				),
				url: ABOUT_TRANSACTION_PAYMENT,
			},
			{
				text: (
					<FormattedMessage id="Footer.links.deferredBilling" defaultMessage="Posunutí splatnost" />
				),
				url: DEFERRED_BILLING,
			},
			{
				text: <FormattedMessage id="Footer.links.aboutInvestment" defaultMessage="Investice" />,
				url: ABOUT_INVESTMENTS,
			},
			{
				text: <FormattedMessage id="Footer.links.pricing" defaultMessage="Ceník" />,
				url: PRICING,
			},
		],
		linksInformations: [
			{
				text: <FormattedMessage id="Footer.links.whereShop" defaultMessage="Kde nakupovat" />,
				url: ROUTES(locale).eshopsList,
			},
			{
				text: <FormattedMessage id="Footer.links.aboutUs" defaultMessage="O nás" />,
				url: ABOUT,
			},
			{
				text: <FormattedMessage id="Footer.links.faq" defaultMessage="Často kladené otázky" />,
				url: PUBLIC_SUPPORT,
			},
			{
				text: <FormattedMessage id="Footer.links.career" defaultMessage="Kariéra" />,
				url: CAREER,
			},
			{
				text: <FormattedMessage id="Footer.links.blog" defaultMessage="Blog" />,
				url: URL_BLOG,
			},
			{
				text: <FormattedMessage id="Footer.links.forMedia" defaultMessage="Pro novináře" />,
				url: FOR_JOURNALISTS,
			},
			{
				text: <FormattedMessage id="Footer.links.documents" defaultMessage="Důležité dokumenty" />,
				url: DOCUMENTS,
			},
			{
				text: <FormattedMessage id="Footer.links.personalInfo" defaultMessage="Osobní údaje" />,
				url: PERSONAL_DATA,
			},
			{
				text: <FormattedMessage id="Footer.links.exchangeRates" defaultMessage="Kurzovní lístek" />,
				url: EXCHANGE_RATES,
			},
			{
				text: <FormattedMessage id="Footer.links.openApi" defaultMessage="OpenAPI (PSD2)" />,
				url: OPEN_API,
			},
			{
				text: <FormattedMessage id="Footer.links.allContacts" defaultMessage="Kontakty" />,
				url: CONTACTS,
			},
		],
		linksForEshops: [
			{
				text: <FormattedMessage id="Footer.links.skipPayForEshop" defaultMessage="Pro e-shopy" />,
				url: GET_MALL_PAY,
			},
			{
				text: <FormattedMessage id="Footer.links.skipPayForDevelopers" defaultMessage="Pro vývojáře (API)" />,
				url: FOR_DEVELOPERS,
			},
			{
				text: <FormattedMessage id="Footer.links.affiliate" defaultMessage="Affiliate program" />,
				url: 'https://affiliate.skippay.cz',
			},
		],
		seoLinks: [
			{
				text: <FormattedMessage id="Footer.links.testimonial" defaultMessage="Recenze klientů" />,
				url: TESTIMONIAL,
			},
			{
				text: <FormattedMessage id="Footer.links.hawToPay" defaultMessage="Jak zaplatit" />,
				url: ABOUT_HOW_PAY_BY_MALL_PAY,
			},
			{
				text: <FormattedMessage id="Footer.links.referrals" defaultMessage="Doporučte nás" />,
				url: PUBLIC_REFERRALS,
			},
			{
				text: (
					<FormattedMessage id="Footer.links.aboutPaymentOnDelivery" defaultMessage="Dobírka" />
				),
				url: ABOUT_PAYMENT_ON_DELIVERY,
			},
			{
				text: <FormattedMessage id="Footer.links.aboutOverdraft" defaultMessage="Kontokorent" />,
				url: ABOUT_OVERDRAFT,
			},
			{
				text: (
					<FormattedMessage id="Footer.links.aboutCreditCard" defaultMessage="Kreditní karta" />
				),
				url: ABOUT_CREDIT_CARD,
			},
			{
				text: (
					<FormattedMessage
						id="Footer.links.aboutDeferredPayment"
						defaultMessage="Odložená platba"
					/>
				),
				url: ABOUT_DEFERRED_PAYMENT,
			},
			{
				text: (
					<FormattedMessage id="Footer.links.aboutPaymentByCard" defaultMessage="Platba kartou" />
				),
				url: ABOUT_PAYMENT_BY_CARD,
			},
			{
				text: (
					<FormattedMessage id="Footer.links.aboutOnlinePayment" defaultMessage="Platba online" />
				),
				url: ABOUT_ONLINE_PAYMENT,
			},
			{
				text: (
					<FormattedMessage id="Footer.links.aboutPaymentGateway" defaultMessage="Platební brána" />
				),
				url: ABOUT_PAYMENT_GATEWAY,
			},
			{
				text: <FormattedMessage id="Footer.links.aboutLoans" defaultMessage="Půjčky" />,
				url: ABOUT_LOANS,
			},
			{
				text: (
					<FormattedMessage id="Footer.links.aboutInstallmentPayment" defaultMessage="Splátky" />
				),
				url: ABOUT_INSTALLMENT_PAYMENT,
			},
			{
				text: <FormattedMessage id="Footer.links.vocabulary" defaultMessage="Slovník pojmů" />,
				url: URL_VOCABULARY,
			},
			{
				text: <FormattedMessage id="Footer.links.affiliatePage" defaultMessage="Slevy" />,
				url: AFFILIATE_PAGE,
			},
			{
				text: <FormattedMessage id="Footer.links.aboutShopWisely" defaultMessage="Nakupujte s rozumem" />,
				url: ABOUT_SHOP_WISELY,
			},
			{
				text: <FormattedMessage id="Footer.links.privacySettings" defaultMessage="Nastavení soukromí" />,
				url: PRIVACY_SETTINGS,
			}
		],
		linksSocial: [
			{
				text: <Facebook />,
				url: URL_FACEBOOK,
				ariaLabel: 'Facebook',
			},
			{
				text: <Youtube />,
				url: URL_YOUTUBE,
				ariaLabel: 'YouTube',
			},
			{
				text: <LinkedIn />,
				url: URL_LINKEDIN,
				ariaLabel: 'LinkedIn',
			},
			{
				text: <Instagram />,
				url: URL_INSTAGRAM,
				ariaLabel: 'Instagram',
			},
			{
				text: <Blog />,
				url: URL_BLOG,
				ariaLabel: 'Blog',
			},
		],
	};
}

export default useFooterLinks;
